<div class="carousel-container">
    <div class="carousel-header">
        <h2 class="image-name">{{ data.images[currentIndex].name }}</h2>
        <button mat-icon-button (click)="close()" class="close-btn">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="carousel-body">
        <button mat-icon-button class="nav-btn prev" (click)="prevImage()" *ngIf="data.images.length > 1">
            <mat-icon>chevron_left</mat-icon>
        </button>

        <div class="image-wrapper">
            <img [src]="data.images[currentIndex].url" alt="Document Image" class="carousel-image"/>
        </div>

        <button mat-icon-button class="nav-btn next" (click)="nextImage()" *ngIf="data.images.length > 1">
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>

    <div class="carousel-footer" *ngIf="data.images.length > 1">
        <div class="dots">
            <span class="dot" *ngFor="let img of data.images; let i = index" [class.active]="i === currentIndex" (click)="currentIndex = i"></span>
        </div>
        <div class="counter text-muted">
            {{ currentIndex + 1 }} of {{ data.images.length }}
        </div>
    </div>
</div>
